import { render, staticRenderFns } from "./ContractAccount.vue?vue&type=template&id=5974ca76&"
import script from "./ContractAccount.vue?vue&type=script&lang=js&"
export * from "./ContractAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports